export const TrustedByCompanies = () => {
  return (
    <div>
      <div className="text-11-16 text-gray-600">Trusted by teams at:</div>
      <div className="mt-6 flex gap-24">
        <img
          src="/assets/customers/reiq.svg"
          alt="Reiq"
          className="grayscale"
        />
        <img
          src="/assets/customers/reddit.svg"
          alt="Reddit"
          className="grayscale"
        />
        <img src="/assets/customers/pwc.svg" alt="PWC" className="grayscale" />
        <img
          src="/assets/customers/yobs.svg"
          alt="Yobs"
          className="grayscale"
        />
      </div>
    </div>
  );
};
